import { AABB } from "../../../Utils/AABB";
import { Point } from "../../../Utils/Point";
import { StopperNamesConstants } from "../../../Constants/StopperNamesConstants";
import { OutfitNamesConstants } from "../../../Constants/OutfitNamesConstants";

export abstract class CollisionSubjectModel {

    public pos: Point = new Point();
    public startPos: Point = new Point();
    public isActive: boolean = true;
    public elapsed = 0;
    public name: StopperNamesConstants | OutfitNamesConstants = StopperNamesConstants.Bench;

    abstract get height(): number
    abstract get width(): number
    abstract get aabb(): AABB
}